import { useState, useEffect } from 'react';
import { updateSocialSetting } from '../../../../services/settingService';

interface SocialSettingsProps {
  settings: any;
  onUpdate: (settings: any) => void;
}

const SocialSettings = ({ settings, onUpdate }: SocialSettingsProps) => {
  const [formData, setFormData] = useState({
    facebook: '',
    zalo: '',
    linkedin: '',
    youtube: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    if (settings?.social) {
      setFormData({
        facebook: settings.social.facebook || '',
        zalo: settings.social.zalo || '',
        linkedin: settings.social.linkedin || '',
        youtube: settings.social.youtube || ''
      });
    }
  }, [settings]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await updateSocialSetting(formData);
      if (response.success) {
        setMessage({ type: 'success', text: response.message || 'Cập nhật thành công' });
        if (onUpdate && response.data) {
          onUpdate(response.data);
        }
      }
    } catch (error: any) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Có lỗi xảy ra khi cập nhật'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-6">Mạng xã hội</h3>
      
      {message.text && (
        <div className={`mb-4 p-4 rounded-lg ${
          message.type === 'success' 
            ? 'bg-green-50 border border-green-200 text-green-800' 
            : 'bg-red-50 border border-red-200 text-red-800'
        }`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Facebook Page
          </label>
          <input
            type="url"
            placeholder="https://facebook.com/yourpage"
            value={formData.facebook}
            onChange={(e) => setFormData({ ...formData, facebook: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A4B7C] focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Zalo
          </label>
          <input
            type="text"
            placeholder="Số Zalo hoặc link Zalo"
            value={formData.zalo}
            onChange={(e) => setFormData({ ...formData, zalo: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A4B7C] focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            LinkedIn
          </label>
          <input
            type="url"
            placeholder="https://linkedin.com/in/yourprofile"
            value={formData.linkedin}
            onChange={(e) => setFormData({ ...formData, linkedin: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A4B7C] focus:border-transparent"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            YouTube
          </label>
          <input
            type="url"
            placeholder="https://youtube.com/c/yourchannel"
            value={formData.youtube}
            onChange={(e) => setFormData({ ...formData, youtube: e.target.value })}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2A4B7C] focus:border-transparent"
          />
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={loading}
            className="bg-[#2A4B7C] hover:bg-[#2A4B7C]/90 disabled:opacity-50 disabled:cursor-not-allowed text-white px-8 py-3 rounded-lg font-semibold transition-colors"
          >
            {loading ? 'Đang lưu...' : 'Lưu thông tin mạng xã hội'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SocialSettings;

